'use client';

import { VStack, HStack, Box } from '@terra/ui-styled-system';
import { HeadingSection, MetaDefault } from '../../components/typography';
import { Tooltip } from '../../components/tooltip';
import { HelpCircleIcon } from '@terra/ui-icons';
import type { ReactNode } from 'react';

export type SettingsSectionProps = {
  title: ReactNode;
  tooltip?: string;
  description?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  fillHeight?: boolean;
};
export function SettingsSection({
  title,
  tooltip,
  description,
  action,
  children,
  fillHeight = false,
}: SettingsSectionProps) {
  return (
    <VStack
      alignItems="stretch"
      gap={4}
      w="full"
      flex={fillHeight ? 1 : undefined}
      minH={fillHeight ? 0 : undefined}
    >
      <HStack justifyContent="space-between" alignItems="flex-start" gap={4}>
        <VStack alignItems="flex-start" gap={1} minW={0}>
          <HStack gap={1} alignItems="center" minW={0}>
            {typeof title === 'string' ? (
              <HeadingSection>{title}</HeadingSection>
            ) : (
              title
            )}
            {tooltip ? (
              <Tooltip title={tooltip} positioning={{ strategy: 'fixed' }}>
                <Box display="flex" color="fg.neutral.muted">
                  <HelpCircleIcon size={16} />
                </Box>
              </Tooltip>
            ) : null}
          </HStack>
          {description ? (
            typeof description === 'string' ? (
              <MetaDefault color="fg.neutral.muted">{description}</MetaDefault>
            ) : (
              description
            )
          ) : null}
        </VStack>
        {action ? <Box flexShrink={0}>{action}</Box> : null}
      </HStack>
      {children}
    </VStack>
  );
}
